import React from "react";
import { useLanguage } from "../contexts/LanguageContext";

const Process = () => {
  const { t } = useLanguage();
  const steps = t.process.steps;

  return (
    <section
      id="process"
      data-testid="process-section"
      className="py-24 sm:py-32 px-5 sm:px-8 bg-white"
    >
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-6 mb-16 items-end">
          <div className="md:col-span-4">
            <div className="flex items-center gap-3 mb-4">
              <span className="w-10 h-px bg-brand" />
              <span className="text-[11px] tracking-[0.25em] font-bold text-brand">
                {t.process.eyebrow}
              </span>
            </div>
          </div>
          <h2
            className="md:col-span-8 font-display text-3xl sm:text-4xl lg:text-5xl font-light tracking-tight text-brand-ink leading-tight"
            data-testid="process-title"
          >
            {t.process.title}
          </h2>
        </div>

        <ol className="relative border-l border-brand-line/70 ml-2 sm:ml-4">
          {steps.map((step, i) => {
            const num = String(i + 1).padStart(2, "0");
            return (
              <li
                key={i}
                data-testid={`process-step-${i + 1}`}
                className="relative pl-8 sm:pl-16 pb-14 last:pb-0 group"
              >
                {/* Dot */}
                <span
                  className="absolute -left-[9px] top-1 w-4 h-4 rounded-full bg-white border-2 border-brand transition-all duration-300 group-hover:bg-brand"
                  aria-hidden
                />

                {/* Giant background number */}
                <span
                  className="absolute left-6 sm:left-10 -top-6 text-7xl sm:text-8xl font-display font-extrabold text-brand/5 leading-none select-none pointer-events-none"
                  aria-hidden
                >
                  {num}
                </span>

                <div className="relative z-10">
                  <div className="text-xs tracking-[0.25em] font-bold text-brand mb-2">
                    STEP {num}
                  </div>
                  <h3 className="font-display text-2xl sm:text-3xl font-medium text-brand-ink tracking-tight mb-2">
                    {step.title}
                  </h3>
                  <p className="text-base text-brand-muted max-w-2xl leading-relaxed">
                    {step.description}
                  </p>
                </div>
              </li>
            );
          })}
        </ol>
      </div>
    </section>
  );
};

export default Process;
